import React from "react";

import { Box, Button } from "@origin-digital/ods-core";
import { IconMenu } from "@origin-digital/ods-icons";

import styled from "styled-components";
import { navigationBarHeight } from "../helpers/consts";

const StyledBox = styled(Box)(({ theme: { shape } }) => ({
  display: "flex",
  alignItems: "center",
  height: navigationBarHeight,

  '& [class*="MuiButton-sizeSmall"]': {
    ".MuiButton-endIcon svg": {
      fontSize: shape.iconSizes.xsmall,
    },
  },
}));

interface IKrakenHamburger {
  onClick: (event: React.KeyboardEvent | React.MouseEvent) => void;
  "data-id": string;
}

export const MenuHamburger = (props: IKrakenHamburger) => {
  return (
    <StyledBox>
      <Button
        variant="outlined"
        size="small"
        icon={<IconMenu color="neutralDark" />}
        iconPosition="trailing"
        {...props}
      >
        Menu
      </Button>
    </StyledBox>
  );
};
